import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getAvailableUserRoles} from 'src/openapi/admin/apis/UserRoleApi';
import {useAppDispatch} from 'src/store';

import type {Role} from 'src/openapi/admin/models/Role';

type Return = {roles: Role[], loading: boolean};

export const useRoles = (userId: number | undefined): Return => {
    const dispatch = useAppDispatch();

    const getDispatchAction = useCallback((signal: AbortSignal) => {
        return dispatch(getAvailableUserRoles({userId: userId!}, {signal}));
    }, [dispatch, userId]);

    const {data: roles, isLoading: loading} = useReadOnlyDataHook({
        initValue: [] as Role[],
        getDispatchAction,
        shouldLoadData: !!userId,
    });
    return {roles, loading};
};
